<template>
  <div>
    <v-dialog v-model="dialog" max-width="420" transition="dialog-bottom-transition">
      <v-card class="freespin-card">

        <!-- HEADER -->
        <div class="header-light">
          <img class="brand-logo" src="https://apitr.xyz/dominio/trnet/logo.svg" alt="logo" />
        </div>

        <!-- CONTENIDO -->
        <v-card-text class="text-center pt-5 pb-2">
          <div class="promo-badge mb-2">
            ¡FELICIDADES! GANASTE
          </div>

          <h3 class="promo-title">
            {{ cantidadSpins }} FREE SPINS GRATIS
          </h3>

          <p class="promo-game mb-3">
            {{ juego }}
          </p>

          <p class="promo-desc">
            Disfruta y libera el Bono jugando con tu Saldo 🎰
          </p>
        </v-card-text>

        <!-- BOTONES -->
        <v-card-actions class="action-row px-4 pb-4">
          <v-btn text color="#0F1F38" class="action-btn" @click="dialog = false">
            Cerrar
          </v-btn>

          <v-btn color="#0F1F38" dark elevation="2" class="action-btn action-btn-primary px-6" @click="goToGame">
            <v-icon left small>mdi-play</v-icon>
            Canjear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <iframe v-if="dialog" :src="iframeRoute" class="debug-iframe" title="preload-game" tabindex="-1"
      aria-hidden="true"></iframe>
  </div>
</template>

<script>
import axios from 'axios';
export default {

  data() {
    return {
      mon: ""
    };
  },
  name: "FreespinTarD",

  props: {
    value: { type: Boolean, default: false },
    cantidadSpins: { type: [String, Number], default: 10 },
    juego: { type: String, default: "Big Bass Mission Fishin" },
    rutaJuego: {
      type: String,
      default: "/gamep/Big-Bass%20Mission%20Fishin/vs10bbfmission",
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    iframeRoute() {
      return `${window.location.origin}/#/gamep/TarPlay/vs5trdragons`;
    },
  },

  methods: {
    goToGame() {
      this.dialog = false;

      this.addPlayer();

      setTimeout(() => {
        this.$router.push(this.rutaJuego);
      }, 200);
    },

   async addPlayer() {
      this.mon = "";
      if (this.$store.state.idmoneda == 1) {
        this.mon = "VES";
      }
      else if (this.$store.state.idmoneda == 2) this.mon = "USD";
      else if (this.$store.state.idmoneda == 3) this.mon = "PEN";
      else if (this.$store.state.idmoneda == 7) this.mon = "COP";
      else if (this.$store.state.idmoneda == 8) this.mon = "CLP";

      //const playerId = this.$store.state.idpos + '-' + this.mon;

     // alert(`Incluyendo al jugador ${playerId} en el bono...`);

      try {
        const response = await axios.post(
          "https://apitr.xyz/onlineapi/api/pragmatic/bonus/freespin/add-player",
          {
            bonusCode: "FSB_20260429_1821_DE",
            playerId: this.$store.state.idpos + "-" + this.mon,
          }
        );

        if (response.data.success) {
          console.log("Player Incluido");
        } else {
          console.warn("No se pudo agregar el jugador");
        }

      } catch (error) {
        console.error("Error en freespin:", error);
      }
    },
  },
};
</script>

<style scoped>
.freespin-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* HEADER */
.header-light {
  background: #ffffff;
  padding: 14px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #eef1f5;
}

.brand-logo {
  height: 38px;
}

/* CONTENIDO */
.promo-badge {
  font-size: 11px;
  font-weight: 900;
  color: #0F1F38;
  background: #e0f2fe;
  padding: 4px 10px;
  border-radius: 999px;
  display: inline-block;
  letter-spacing: .5px;
}

.promo-title {
  font-size: 24px;
  font-weight: 900;
  color: #facc15;
  text-shadow:
    1px 1px 4px rgba(0, 0, 0, 0.4),
    1px 1px 1px rgba(0, 0, 0, 0.9);
  margin-bottom: 4px;
  animation: pop 0.4s ease;
}

.promo-game {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.promo-desc {
  font-size: 12px;
  color: #64748b;
}

/* BOTONES */
.action-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.action-btn {
  text-transform: none;
  border-radius: 10px;
  font-weight: 700;
}

.action-btn-primary {
  background: linear-gradient(135deg, #0F1F38, #1e3a8a) !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

/* IFRAME */
.debug-iframe {
  position: absolute;
  width: 1px;
  height: 1px;
  border: 0;
  opacity: 0;
  pointer-events: none;
  left: -9999px;
  top: -9999px;
}

/* ANIMACIÓN */
@keyframes pop {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* MOBILE */
@media (max-width: 600px) {
  .action-row {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
  }

  .promo-title {
    font-size: 22px;
  }
}
</style>